import { createSlice } from '@reduxjs/toolkit';
import axios from '../axios-pogo';
import {addGyms, addPokemon, addStops, addPortals} from "./markerSlice";
import {isDevel, restructureObject} from "../utils";
import {setFilters} from "./filterSlice";
import {setGiovanni} from "./markerSlice";
import cookie from "react-cookies";
import {setDefenders} from "./defenderSlice";

export const Page = {
	LIVE: 1,
	NESTS: 2,
	S2: 3,
};

const coreSlice = createSlice({
	name: 'core',
	initialState: {
		discordUser: null,
		bootstrapped: false,
		mapLoaded: false,
		showError: null,
		badges: {},
		weather: {},
		showFilters: false,
		showSettings: false,
		gpsLocation: null,
		moves: null,
		lastTs: 0,
		nestPolygons: null,
		presets: [],
		pendingSubmissions: null,
		news: null,
		page: Page.LIVE,
		isAdmin: false
	},
	reducers: {
		setDiscordUser(state, action) {	state.discordUser = action.payload;	},
		setBootstrapped(state, action) { state.bootstrapped = action.payload; },
		setMapLoaded(state, action) { state.mapLoaded = action.payload; },
		showError(state, action) { state.showError = action.payload; },
		setBadges(state, action) { if( action.payload ) state.badges = action.payload; },
		setBadge(state, action) { state.badges[action.payload.gymId] = action.payload.val; },
		setShowFilters(state, action) {	state.showFilters = action.payload;	},
		setShowSettings(state, action) { state.showSettings = action.payload;	},
		setGpsLocation(state, action) {	state.gpsLocation = action.payload; },
		setMoves(state, action) {	state.moves = action.payload; },
		setTs(state, action) { state.lastTs = action.payload; },
		setWeather(state, action) {
			Object.keys(action.payload).forEach(s2 => {
				state.weather[s2] = action.payload[s2];
			});
		},
		setPage(state, action) { state.page = action.payload; },
		setNestPolygons(state, action) { state.nestPolygons = action.payload; },
		setPresets(state, action) { state.presets = action.payload; },
		presetDeleted(state, action) { state.presets = state.presets.filter(preset => preset.filter_id !== action.payload)},
		presetEdited(state, action) { state.presets = state.presets.map(
			preset => preset.filter_id === action.payload.filter_id ? action.payload : preset
		)},
		newsSet(state, action) { state.news = action.payload; },
		setPendingSubmissions(state, action) { state.pendingSubmissions = action.payload; },
		pendingSubmissionAdded(state, action) { state.pendingSubmissions[action.payload.key] = action.payload.val; },
		pendingSubmissionRemoved(state, action) { delete state.pendingSubmissions[action.payload]; },
		setIsAdmin(state, action) { state.isAdmin = !!action.payload; },
	}
});

export const { setBootstrapped, setMapLoaded, setDiscordUser, showError, setBadge, setBadges, setShowSettings,
	setShowFilters, setWeather, setGpsLocation, setMoves, setTs, setPage, setNestPolygons, newsSet,
	setPresets, presetDeleted, presetEdited, setIsAdmin,
	setPendingSubmissions, pendingSubmissionAdded, pendingSubmissionRemoved } = coreSlice.actions;

export const bootstrap = (filterId=null) => {
	return (dispatch, getState) => {
		// const state = getState();
		axios.post("/mod/pokemon/map/ajax/bootstrap.php", {
			filter_id: filterId,
			discord: cookie.load('discord')
		}).then(result => {
			if( result.data.filters )
				dispatch(setFilters(JSON.parse(result.data.filters)));
			if( result.data.news )
				dispatch(newsSet(result.data.news));
			dispatch(setDiscordUser(result.data.discordUser));
			dispatch(setBadges(result.data.badges));
			dispatch(setMoves(result.data.moves));
			if( result.data.presets )
				dispatch(setPresets(result.data.presets));
			dispatch(setBootstrapped(true));
			dispatch(setGiovanni(result.data.giovanni));
			if( result.data.isAdmin )
				dispatch(setIsAdmin(true));
			if( result.data.defenders && result.data.defenders.length )
				dispatch(setDefenders(result.data.defenders));
		}).catch(error => {
			dispatch(showError("Error loading data. Please refresh page."));
		});
	}
};



export const fetchData = (onlyNew=true) => {
	return (dispatch, getState) => {
		const state = getState();

		if( !state.map.mapBounds )
			return;

		if( state.core.page === Page.NESTS )
			return;

		const post = {
			lat_min: state.map.mapBounds[1][0],
			lat_max: state.map.mapBounds[0][0],
			lng_min: state.map.mapBounds[1][1],
			lng_max: state.map.mapBounds[0][1],
			showGyms: state.filter.showGyms,
			showRaids: state.filter.showRaids,
			showPokemon: state.filter.showPokemon,
			showStops: state.filter.showStops,
			stopOverlay: state.filter.stopOverlay,
			allStops: state.filter.stopShowAll,
			threshold: state.filter.pokemonQuality,
			ts: onlyNew ? state.core.lastTs : 0,
		};

		if( state.core.page === Page.S2 )
			post['s2'] = true;

		if( state.core.gpsLocation ) {
			post['lat'] = state.core.gpsLocation[0];
			post['lng'] = state.core.gpsLocation[1];
		}

		if( isDevel() )
			post['isDevel'] = true;

		axios.post("/mod/pokemon/map/ajax/get-data.php", post).then(result => {
			result.data.gyms    && dispatch(addGyms(restructureObject(result.data.gyms)));
			result.data.pokemon && dispatch(addPokemon(restructureObject(result.data.pokemon)));
			result.data.stops   && dispatch(addStops(restructureObject(result.data.stops)));
			result.data.weather && dispatch(setWeather(result.data.weather));
			if( result.data.pendingSubmissions )
				dispatch(setPendingSubmissions(result.data.pendingSubmissions));
			if( result.data.portals )
				dispatch(addPortals(result.data.portals));
			dispatch(setTs(result.data.ts));
		}).catch(error => {
			console.log("Error loading data: ", error);
			dispatch(showError("Error loading data. Please refresh page."));
		});
	}
};

export const fetchNestPolygons = () => {
	return (dispatch, getState) => {
		axios.get("/mod/pokemon/map/ajax/get-nests.php").then(result => {
			dispatch(setNestPolygons(result.data));
		}).catch(error => {
			console.log("Error loading nests: ", error);
			dispatch(showError("Error loading nests. Please refresh page."));
		});
	}
};

export const updateBadge = (gymId, val) => {
	return (dispatch, getState) => {
		axios.post("/mod/pokemon/map/ajax/update-badge.php", {
			gym_id: gymId,
			value: val
		}).then(result => {
			dispatch(setBadge({gymId, val}));
		}).catch(error => {
			console.log("Error loading data: ", error);
			dispatch(showError("Error saving badge. Please refresh page."));
		});
	}
};

// WARN: this will exit the app
export const linkDiscord = () => {
	return (dispatch, getState) => {
		axios.get("/mod/pokemon/map/ajax/get-discord-auth-url.php").then(result => {
			window.location.href = result.data.url;
		});
	}
};

export const addPendingSubmission = (latitude, longitude, key) => {
	return (dispatch, getState) => {
		axios.post("/mod/pokemon/map/ajax/add-s2-submission.php", {
			latitude, longitude
		}).then(result => {
			dispatch(pendingSubmissionAdded({key, val: result.data}));
		}).catch(error => {
			console.log("Error adding pending submission: ", error);
			dispatch(showError("Error adding submission. Please refresh page."));
		});
	}
};

export const removePendingSubmission = (latitude, longitude, key) => {
	return (dispatch, getState) => {
		axios.post("/mod/pokemon/map/ajax/add-s2-submission.php", {
			latitude, longitude, remove: 1
		}).then(result => {
			dispatch(pendingSubmissionRemoved(key));
		}).catch(error => {
			console.log("Error adding pending submission: ", error);
			dispatch(showError("Error adding submission. Please refresh page."));
		});
	}
};



export default coreSlice.reducer;